import { IServerResponse } from 'Utilities/ClientResponseUtility';
import { SitecoreFetch } from 'Api/api/SitecoreApi';

export async function GetRecentActivities(tableName: string, agencyCode: string): Promise<IServerResponse> {
  let controller = '';
  let method = '';
  switch (tableName) {
    case 'billing': {
      controller = 'BillingAsync';
      method = 'GetBillingRecentActivities';
      break;
    }
    case 'claims': {
      controller = 'ClaimAsync';
      method = 'GetClaimsRecentActivities';
      break;
    }
    case 'policy': {
      controller = 'PolicyAsync';
      method = 'GetPolicyRecentActivities';
      break;
    }
  }

  let path = `/api/sitecore/${controller}/${method}?agencyCode=${agencyCode}`;
  let result = await SitecoreFetch(path);
  return result;
}
